// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"b9a6472e","453":"b63d2120","948":"8b1a8988"}[chunkId] + ".chunk.js";
};